import React, { useEffect } from 'react';
import { Route, Routes, NavLink, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Drawer, Toolbar, Typography, List, ListItem, ListItemText, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import AdsProtectedRoute from '../../components/AdsProtectedRoute';
import AdsPayments from './AdsPayments';
import AdsReports from './AdsReports';
import MyAds from './MyAds';
import CreateAd from './CreateAd';

const drawerWidth = 240;

const Root = styled('div')({
  display: 'flex',
});

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 16px',
}));

const StyledDrawer = styled(Drawer)({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
  },
});

const MainContent = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}));

const sidebarItems = [
  { text: 'My Ads', path: '/ads/dashboard/ads' },
  { text: 'Create Ad', path: '/ads/dashboard/create' },
  { text: 'Analytics', path: '/ads/dashboard/reports' },
  { text: 'Payments', path: '/ads/dashboard/payments' },
];

const AdsDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const adToken = localStorage.getItem('adToken');
    if (!adToken) {
      navigate('/ads/login', { state: { from: location } });
    }
  }, [navigate, location]);

  const handleLogout = () => {
    localStorage.removeItem('adToken');
    localStorage.removeItem('adUser');
    navigate('/ads/login');
  };

  return (
    <AdsProtectedRoute>
      <Root>
        <StyledAppBar position="fixed">
          <Typography variant="h6" noWrap>
            Ad Creator Dashboard
          </Typography>
          <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{ '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' } }}
          >
            Logout
          </Button>
        </StyledAppBar>

        <StyledDrawer variant="permanent">
          <Toolbar />
          <List>
            {sidebarItems.map(({ text, path }) => (
              <ListItem key={path} component={NavLink} to={path} button>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </StyledDrawer>

        <MainContent>
          <Toolbar />
          <Routes>
            <Route path="/" element={<Navigate to="ads" replace />} />
            <Route path="ads" element={<MyAds />} />
            <Route path="create" element={<CreateAd />} />
            <Route path="reports" element={<AdsReports />} />
            <Route path="payments" element={<AdsPayments />} />
            <Route path="*" element={<Navigate to="ads" replace />} />
          </Routes>
        </MainContent>
      </Root>
    </AdsProtectedRoute>
  );
};

export default AdsDashboard;
